import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0319d0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "Header-testnet"
}
const _hoisted_2 = { class: "Header-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Header-logoIcon" }, null, -1))
const _hoisted_4 = { class: "Header-logoLabel" }
const _hoisted_5 = { class: "Header-menu" }
const _hoisted_6 = {
  key: 1,
  class: "Header-menuWrapper"
}
const _hoisted_7 = ["data-icon"]
const _hoisted_8 = { class: "Header-menuList" }
const _hoisted_9 = { "data-id": "address" }
const _hoisted_10 = { "data-id": "disconnect" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["Header", { isScrolled: _ctx.isScrolled }])
  }, [
    (_ctx.isTestnet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t(`testnetMessage`)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isHistoryShown ? 'NuxtLink' : 'div'), {
        to: _ctx.parentUrl,
        class: _normalizeClass(["Header-logo", { isHistoryShown: _ctx.isHistoryShown }])
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(`logoLabel`)), 1)
        ]),
        _: 1
      }, 8, ["to", "class"])),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.showMenu)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onConnectEthereumWalletClick && _ctx.onConnectEthereumWalletClick(...args))),
              class: "Header-connectEthereumButton"
            }, " Connect Ethereum "))
          : _createCommentVNode("", true),
        (_ctx.showMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "Header-menuAddress",
                "data-icon": _ctx.ethereumProvider?.name
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.address), 1)
              ], 8, _hoisted_7),
              _createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.address), 1)
                ]),
                _createElementVNode("li", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDisconnectClick && _ctx.onDisconnectClick(...args))),
                    disabled: _ctx.disableDisconnect
                  }, _toDisplayString(_ctx.$t(`disconnectWallet`)), 9, _hoisted_11)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}